const USER_STORAGE=JSON.parse(localStorage.getItem("sangeetUser"))

export const initialState=USER_STORAGE!==null


export const reducer=(state,action)=>{
    
    if(action.type === "USER"){
        return action.payload
    }

    return state
}